export const DestinationContentSources = {
    AI: 0,
    MANUAL: 1,
    FROM_GUIDES: 2,
} as const;
